module.exports = __webpack_public_path__ + "static/media/26_tn.f8108412.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/26_tn.jpg
// module id = 662
// module chunks = 0